import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["disabled", "aria-disabled"]

import { Checkbox as RcCheckbox } from '@components/Form/Checkbox';
import { useDropdownItem } from '@components/RcDropdown/useDropdownItem';


export default /*@__PURE__*/_defineComponent({
  __name: 'RcDropdownItemCheckbox',
  props: { modelValue: Boolean, disabled: Boolean },
  emits: ['click'],
  setup(__props, { emit: __emit }) {

/**
 * An item for a dropdown menu. Used in conjunction with RcDropdown.
 */
const props = __props;
const emits = __emit;

const { handleKeydown, handleActivate, scrollIntoView } = useDropdownItem();

const handleClick = () => {
  if (props.disabled) {
    return;
  }

  emits('click', !props.modelValue);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    ref: "dropdownMenuItem",
    "dropdown-menu-item": "",
    tabindex: "-1",
    role: "menuitemcheckbox",
    disabled: __props.disabled || null,
    "aria-disabled": __props.disabled || false,
    onClick: _withModifiers(handleClick, ["stop"]),
    onKeydown: [
      _cache[0] || (_cache[0] = _withKeys(
//@ts-ignore
(...args) => (_unref(handleActivate) && _unref(handleActivate)(...args)), ["enter","space"])),
      _cache[1] || (_cache[1] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_unref(handleKeydown) && _unref(handleKeydown)(...args)), ["prevent","stop"]), ["up","down"]))
    ],
    onFocusin: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_unref(scrollIntoView) && _unref(scrollIntoView)(...args)))
  }, [
    _createVNode(_unref(RcCheckbox), { value: __props.modelValue }, {
      label: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["value"])
  ], 40, _hoisted_1))
}
}

})